import { PLATFORM } from "hoxton-shared/enums/exports";

export const FilterType = {
    CommentedOnBy: "CommentedOnBy",
    GroupValue: "GroupValue",
    PublishedStatus: "PublishedStatus",
    Size: "Size",
    Status: "Status",
    UserStatus: "UserStatus",
    Text: "Text",
    Language: "Language",
    VisibleTo: "VisibleTo",
    Misc: "Misc",
    CreativeXScore: "CreativeXScore",
    CreativeXStatus: "CreativeXStatus",
    SataliaStatus: "SataliaStatus"
} as const;

export const UrlFilterParams = {
    CommentedOnBy: "cob",
    DeliverableDrawerIsVisible: "dd",
    GroupValue: "gv",
    MetadataSearch: "mds",
    Page: "p",
    PageSize: "ps",
    PublishedStatus: "pst",
    Size: "sz",
    Status: "st",
    Text: "q",
    UserStatus: "ust",
    Language: "lng",
    ViewMode: "vm",
    VisibleTo: "vt",
    Misc: "msc",
    CreativeXScore: "cx-sc",
    CreativeXStatus: "cx-status",
    SataliaStatus: "sat-status"
} as const;

export const ViewMode = {
    Grid: "grid",
    Table: "table"
} as const;

export const ViewModeDefaultPageSize = {
    [ViewMode.Grid]: 10,
    [ViewMode.Table]: 25
} as const;

export const LibraryDrawerTab = {
    QA: "qa",
    Preview: "preview"
} as const;

export const PreviewDrawerTab = {
    Preview: "preview",
    DoubleClick: PLATFORM.DOUBLECLICK,
    OpenDC: PLATFORM.OPENDC
} as const;
